import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getGroupMembers} from 'src/openapi/admin/apis/GetGroupMembersApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    groupId: number,
};

export const useGetGroupMembers = ({groupId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getGroupMembers({groupId}),
    ), [groupId, apiDispatch]);

    return useReadOnlyDataHook({getDispatchAction, initValue: []});
};
